import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getAllCategories } from '../services/homeFeed';

// Async Thunk to Fetch Categories
export const fetchAllCategories = createAsyncThunk(
  'categories/fetchAllCategories',
  async (_, { rejectWithValue }) => {
    try {
      const response = await getAllCategories();
      return response.data.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

const categoriesSlice = createSlice({
  name: 'categories',
  initialState: {
    allCategories: [],
    isLoading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAllCategories.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchAllCategories.fulfilled, (state, action) => {
        state.isLoading = false;
        state.allCategories = action.payload;
      })
      .addCase(fetchAllCategories.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });
  },
});
// const categoriesSlice = createSlice({
//   name: 'categories',
//   initialState: {
//     allCategories: [],
//     filteredCategories: [],
//     isLoading: false,
//     error: null,
//   },
//   reducers: {
//     filterCategories: (state, action) => {
//       const { isLoggedIn } = action.payload;
//       console.log("action",action.payload)
//       // Update the logic to show categories that either:
//       // 1. Don't require login (requires_login === 0 or null/undefined)
//       // 2. Do require login (requires_login === 1) but user is logged in
//       state.filteredCategories = state.allCategories.filter(category => 
//         !category.requires_login || (category.requires_login === 1 && isLoggedIn)
//       );
//     },
//   },
//   extraReducers: (builder) => {
//     builder
//       .addCase(fetchAllCategories.pending, (state) => {
//         state.isLoading = true;
//       })
//       .addCase(fetchAllCategories.fulfilled, (state, action) => {
//         state.isLoading = false;
//         state.allCategories = action.payload;
//         // Also filter categories whenever new categories are fetched
//         // This ensures filteredCategories is always in sync
//         state.filteredCategories = state.allCategories.filter(category => 
//           !category.requires_login || (category.requires_login === 1 && state.isLoggedIn)
//         );
//       })
//       .addCase(fetchAllCategories.rejected, (state, action) => {
//         state.isLoading = false;
//         state.error = action.payload;
//       });
//   },
// });

// export const { filterCategories } = categoriesSlice.actions;
export default categoriesSlice.reducer;